import { Input } from "@components/shadcn-ui/input";
import { cn } from "@lib/utils";
import { Search } from "lucide-react";
import React, { useState, useEffect } from "react";

interface SearchInputProps {
  searchQuery: string;
  handleSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  messages?: string[];
}

export const SearchInput: React.FC<SearchInputProps> = ({
  searchQuery,
  handleSearchChange,
  className = "rounded-lg px-12 text-muted-foreground",
  messages = [
    "Search for leads by name",
    "Search for leads by phone number",
    "Find leads quickly",
    "Search leads by email address",
  ],
}) => {
  const [placeholder, setPlaceholder] = useState<string>("");
  const [messageIndex, setMessageIndex] = useState<number>(0);
  const [charIndex, setCharIndex] = useState<number>(0);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (charIndex < messages[messageIndex].length) {
      timeout = setTimeout(() => {
        setPlaceholder((prev) => prev + messages[messageIndex][charIndex]);
        setCharIndex((prev) => prev + 1);
      }, 100);
    } else {
      timeout = setTimeout(() => {
        setPlaceholder("");
        setCharIndex(0);
        setMessageIndex((prev) => (prev + 1) % messages.length);
      }, 2000);
    }

    return () => clearTimeout(timeout);
  }, [charIndex, messageIndex, messages]);

  return (
    <div className="flex justify-center relative w-full md:w-[350px] ">
      <Search className="absolute text-gray-500 top-3 left-4" />
      <Input
        type="text"
        className={cn("h-12", className)}
        placeholder={placeholder}
        value={searchQuery}
        onChange={handleSearchChange}
      />
    </div>
  );
};
